// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "attribute_name": {
      "column": {
        "default": null,
        "name": "attribute_name",
        "null": true,
        "type": "string"
      },
      "name": "attribute_name",
      "selected_by_default": null,
      "translated": null
    },
    "identifier": {
      "column": {
        "default": null,
        "name": "identifier",
        "null": false,
        "type": "string"
      },
      "name": "identifier",
      "selected_by_default": null,
      "translated": null
    },
    "label": {
      "column": {
        "default": null,
        "name": "label",
        "null": false,
        "type": "string"
      },
      "name": "label",
      "selected_by_default": null,
      "translated": null
    },
    "path": {
      "column": {
        "default": null,
        "name": "path",
        "null": true,
        "type": "jsonb"
      },
      "name": "path",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": null,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "props_column": {
      "column": {
        "default": null,
        "name": "props_column",
        "null": true,
        "type": "boolean"
      },
      "name": "props_column",
      "selected_by_default": null,
      "translated": null
    },
    "sort_key": {
      "column": {
        "default": null,
        "name": "sort_key",
        "null": true,
        "type": "string"
      },
      "name": "sort_key",
      "selected_by_default": null,
      "translated": null
    },
    "text_center": {
      "column": {
        "default": false,
        "name": "text_center",
        "null": false,
        "type": "boolean"
      },
      "name": "text_center",
      "selected_by_default": null,
      "translated": null
    },
    "text_right": {
      "column": {
        "default": false,
        "name": "text_right",
        "null": false,
        "type": "boolean"
      },
      "name": "text_right",
      "selected_by_default": null,
      "translated": null
    },
    "visible": {
      "column": {
        "default": true,
        "name": "visible",
        "null": false,
        "type": "boolean"
      },
      "name": "visible",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "TableSettingColumn",
  "collectionKey": "table_setting_columns",
  "collectionName": "table_setting_columns",
  "i18nKey": "table_setting_column",
  "camelizedLower": "tableSettingColumn",
  "name": "TableSettingColumn",
  "nameDasherized": "table-setting-column",
  "pluralName": "table_setting_columns",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "TableSetting",
      "collectionName": "table_settings",
      "foreignKey": "table_setting_id",
      "name": "table_setting",
      "macro": "belongs_to",
      "resource_name": "TableSetting",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "attribute_name",
      "column": {
        "default": null,
        "name": "attribute_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "label",
      "column": {
        "default": null,
        "name": "label",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "path",
      "column": {
        "default": null,
        "name": "path",
        "null": true,
        "type": "jsonb"
      }
    },
    {
      "name": "position",
      "column": {
        "default": null,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "props_column",
      "column": {
        "default": null,
        "name": "props_column",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "sort_key",
      "column": {
        "default": null,
        "name": "sort_key",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "table_setting_id",
      "column": {
        "default": null,
        "name": "table_setting_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "text_center",
      "column": {
        "default": false,
        "name": "text_center",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "text_right",
      "column": {
        "default": false,
        "name": "text_right",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "visible",
      "column": {
        "default": true,
        "name": "visible",
        "null": false,
        "type": "boolean"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "table_setting_column",
  "primaryKey": "id"
}

/** Frontend model for TableSettingColumn. */
export default class TableSettingColumn extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  attributeName() {
    return this.readAttributeUnderscore("attribute_name")
  }

  /** @returns {boolean} */
  hasAttributeName() {
    const value = this.attributeName()

    return this._isPresent(value)
  }

  /** @returns {string} */
  identifier() {
    return this.readAttributeUnderscore("identifier")
  }

  /** @returns {boolean} */
  hasIdentifier() {
    const value = this.identifier()

    return this._isPresent(value)
  }

  /** @returns {string} */
  label() {
    return this.readAttributeUnderscore("label")
  }

  /** @returns {boolean} */
  hasLabel() {
    const value = this.label()

    return this._isPresent(value)
  }

  /** @returns {Record<string, any> | Array<any> | null} */
  path() {
    return this.readAttributeUnderscore("path")
  }

  /** @returns {boolean} */
  hasPath() {
    const value = this.path()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {boolean | null} */
  propsColumn() {
    return this.readAttributeUnderscore("props_column")
  }

  /** @returns {boolean} */
  hasPropsColumn() {
    const value = this.propsColumn()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  sortKey() {
    return this.readAttributeUnderscore("sort_key")
  }

  /** @returns {boolean} */
  hasSortKey() {
    const value = this.sortKey()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  textCenter() {
    return this.readAttributeUnderscore("text_center")
  }

  /** @returns {boolean} */
  hasTextCenter() {
    const value = this.textCenter()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  textRight() {
    return this.readAttributeUnderscore("text_right")
  }

  /** @returns {boolean} */
  hasTextRight() {
    const value = this.textRight()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  visible() {
    return this.readAttributeUnderscore("visible")
  }

  /** @returns {boolean} */
  hasVisible() {
    const value = this.visible()

    return this._isPresent(value)
  }
}
